import { Heart, Users, Award, Target } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { companyInfo } from '../data/mock';

export const Sobre = () => {
  const values = [
    {
      icon: Heart,
      title: 'Paixão por Beleza',
      description: 'Selecionamos os melhores produtos para realçar sua beleza natural'
    },
    {
      icon: Users,
      title: 'Atendimento Especial',
      description: 'Equipe dedicada para ajudar você a encontrar o produto ideal'
    },
    {
      icon: Award,
      title: 'Qualidade Garantida',
      description: 'Trabalhamos apenas com marcas reconhecidas e produtos originais'
    },
    {
      icon: Target,
      title: 'Compromisso',
      description: 'Sua satisfação é a nossa maior prioridade'
    }
  ];

  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="sobre-page">
      {/* Hero */}
      <section className="relative py-20 md:py-32 bg-[#0A0A0A] overflow-hidden">
        <div className="absolute inset-0 opacity-20" style={{
          backgroundImage: `url('https://static.prod-images.emergentagent.com/jobs/e7485edb-125e-4bcd-87b2-265b3dfb4a6c/images/db3d3c973badd6d3ac39ff6601210952a36ba8bcd2e264eaf87378343e68328d.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}></div>
        <div className="container mx-auto px-6 md:px-12 text-white relative z-10">
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#EA1266] mb-4 block">Quem Somos</span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight max-w-2xl" data-testid="sobre-title">
            Sobre a Disneylândia <span className="text-[#EA1266]">Cosméticos</span>
          </h1>
          <p className="text-base text-gray-400 mt-6 font-medium max-w-lg leading-relaxed">
            Referência em beleza e presentes em Canaã dos Carajás
          </p>
        </div>
      </section>

      {/* Company Description */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-6 md:px-12">
          <div className="max-w-4xl mx-auto">
            <Card className="bg-white rounded-2xl border border-gray-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
              <CardContent className="p-8 md:p-12">
                <h2 className="text-2xl sm:text-3xl font-medium text-[#0A0A0A] mb-6 tracking-tight">Nossa História</h2>
                <p className="text-base text-[#4B5563] leading-relaxed mb-8 font-medium">
                  {companyInfo.about}
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="text-center p-6 bg-pink-50/50 rounded-2xl">
                    <div className="text-3xl font-bold text-[#EA1266] mb-2">100+</div>
                    <div className="text-xs text-[#4B5563] uppercase tracking-wider font-medium">Produtos</div>
                  </div>
                  <div className="text-center p-6 bg-green-50/50 rounded-2xl">
                    <div className="text-3xl font-bold text-[#64BC46] mb-2">20+</div>
                    <div className="text-xs text-[#4B5563] uppercase tracking-wider font-medium">Marcas Parceiras</div>
                  </div>
                  <div className="text-center p-6 bg-pink-50/50 rounded-2xl">
                    <div className="text-3xl font-bold text-[#EA1266] mb-2">100%</div>
                    <div className="text-xs text-[#4B5563] uppercase tracking-wider font-medium">Originais</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-6 md:px-12">
          <div className="text-center mb-16">
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#EA1266] mb-4 block">Nossos Valores</span>
            <h2 className="text-3xl sm:text-4xl font-medium text-[#0A0A0A] tracking-tight">
              O Que Nos <span className="text-[#EA1266]">Move</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            {values.map((value, index) => {
              const Icon = value.icon;
              const isPink = index % 2 === 0;
              return (
                <Card key={index} className="text-center bg-white rounded-2xl border border-gray-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgb(234,18,102,0.1)] transition-all duration-300 hover:-translate-y-1 group">
                  <CardContent className="p-8">
                    <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-5 group-hover:scale-110 transition-transform duration-300`} style={{backgroundColor: isPink ? '#EA126615' : '#64BC4615'}}>
                      <Icon size={28} style={{color: isPink ? '#EA1266' : '#64BC46'}} />
                    </div>
                    <h3 className="text-lg font-medium mb-3 text-[#0A0A0A]">{value.title}</h3>
                    <p className="text-sm text-[#4B5563] font-medium leading-relaxed">{value.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-16 md:py-24 bg-[#0A0A0A] text-white">
        <div className="container mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <Card className="bg-white/5 backdrop-blur-sm border-white/10 rounded-2xl">
              <CardContent className="p-8">
                <h3 className="text-xl font-medium mb-4">Nossa <span className="text-[#EA1266]">Missão</span></h3>
                <p className="text-gray-300 leading-relaxed font-medium text-sm">
                  Proporcionar experiências únicas de beleza e bem-estar, oferecendo produtos de alta qualidade
                  com atendimento personalizado que transforma cada visita em um momento especial.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-white/5 backdrop-blur-sm border-white/10 rounded-2xl">
              <CardContent className="p-8">
                <h3 className="text-xl font-medium mb-4">Nossa <span className="text-[#64BC46]">Visão</span></h3>
                <p className="text-gray-300 leading-relaxed font-medium text-sm">
                  Ser a referência em cosméticos e presentes em Canaã dos Carajás e região,
                  reconhecida pela excelência no atendimento e pela curadoria das melhores marcas do mercado.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};
